import React, { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import NavStruct from '../components/NavStruct';
import useServerTable from '../libs/useServerTable';
import axios from '../libs/httpClient';
import { host } from '../libs/webRTC';

export default function LessonList() {
    const table = useServerTable('subjects', {}, {}, '_id');
    const [name, setName] = useState('');
    const [inserted, setInserted] = useState([]);
    const [deleted, setDeleted] = useState([]);
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const remove = row => {
        if (!window.confirm(`Вы действительно хотите удалить предмет "${row._id}"?`)) return;
        setDeleted(previous => [...previous.filter(item => item._id !== row._id), row]);
    };
    const save = async () => {
        setSaving(true); setError('');
        try {
            await axios.post(`${host}/subjects/update`, { inserted, deleted });
            setInserted([]); setDeleted([]); table.reload();
            window.alert('Данные успешно обновлены!');
        } catch (_) { setError('Не удалось сохранить изменения. Повторите попытку.'); }
        finally { setSaving(false); }
    };
    const columns = [
        { dataField: '_id', text: 'Название предмета', sort: true, filter: textFilter({ placeholder: 'Поиск по предмету...' }) },
        { dataField: '_actions', text: '', formatter: (_, row) => deleted.some(item => item._id === row._id)
            ? <Button onClick={() => setDeleted(previous => previous.filter(item => item._id !== row._id))}>Отменить удаление</Button>
            : <Button className="deleteBtn" disabled={saving} onClick={() => remove(row)}>Удалить</Button> }
    ];
    return <Box sx={{ margin: '20px 50px' }}>
        <NavStruct/>
        {(table.error || error) && <p role="alert">{error || table.error} <Button onClick={table.reload}>Повторить</Button></p>}
        {table.loading && <p role="status">Загрузка...</p>}
        <BootstrapTable keyField="_id" data={table.rows} columns={columns} filter={filterFactory()}
            remote={{ pagination: true, filter: true, sort: true }} onTableChange={table.onTableChange}
            defaultSorted={[{ dataField: '_id', order: 'desc' }]}
            pagination={paginationFactory({ page: table.page, sizePerPage: table.limit, totalSize: table.total, sizePerPageList: [10, 25, 50, 100], showTotal: true })}/>
        <TextField id="lesson_name" label="Название предмета" value={name} onChange={event => setName(event.target.value)} disabled={saving}/>
        <Button disabled={saving} onClick={() => {
            const value = name.trim();
            if (!value) return window.alert('Нужно ввести название предмета!');
            if (inserted.some(item => item._id === value)) return;
            setInserted(previous => [...previous, { _id: value, new: true }]); setName('');
        }}>Добавить</Button>
        {inserted.map(item => <p key={item._id}>{item._id} (новый) <Button disabled={saving} onClick={() => setInserted(previous => previous.filter(row => row._id !== item._id))}>Отменить</Button></p>)}
        {deleted.length > 0 && <p>К удалению: {deleted.map(item => item._id).join(', ')}</p>}
        <Button disabled={saving || (!inserted.length && !deleted.length)} onClick={save}>Сохранить изменения</Button>
    </Box>;
}
